import {
  GitHub as GitHubIcon,
  School as SchoolIcon,
  Star as StarIcon,
  EmojiObjects as EmojiObjectsIcon,
} from '@material-ui/icons'

import { Link as GatsbyLink } from 'gatsby'
import React from 'react'
import { grey } from '@material-ui/core/colors'

const activeStyle = { backgroundColor: grey[100] }
export const PROD_SITE_URL = 'https://flvyu.com'
export const DRAWER_SITE_LINKS = [
  {
    isVisible: true,
    name: 'tech blog',
    component: GatsbyLink,
    primary: 'Tech Blog',
    linkProps: {
      to: '/blog/',
      partiallyActive: true,
      activeStyle,
    },
    icon: <StarIcon color="primary" />,
  },
  {
    isVisible: true,
    name: 'Writings',
    component: GatsbyLink,
    primary: 'Writings',
    linkProps: {
      to: '/thoughts/',
      partiallyActive: true,
      activeStyle,
    },
    icon: <EmojiObjectsIcon color="primary" />,
  },
  {
    isVisible: true,
    name: 'github',
    component: 'a',
    primary: 'Github',
    linkProps: {
      href: 'https://github.com/flvyu',
      target: '_blank',
      rel: 'noopener noreferrer',
    },
    icon: <GitHubIcon color="primary" />,
  },
  {
    isVisible: true,
    name: 'Course Work',
    component: GatsbyLink,
    primary: 'Course Work',
    linkProps: {
      to: `/course-work/`,
      partiallyActive: true,
      activeStyle,
    },
    icon: <SchoolIcon color="primary" />,
  },
]

export const BLOG_SITE_META = {
  title: `flvyu's blog`,
  description: 'Programming tips, tricks, and more from flvyu!',
  hashtags: ['react', 'learnToCode', 'gatsbyjstutorials', 'javascript'],
  source: PROD_SITE_URL,
}
